import { simplePath } from "../utils.js";
const GET_ORGANIZATION_LIST_PATH = '/v2/user/:userEmail/organization-list';
function get_organization_list_path(params) {
    return simplePath(GET_ORGANIZATION_LIST_PATH, params);
}
export { GET_ORGANIZATION_LIST_PATH, get_organization_list_path };
